import { CurrencyPipe } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorsHandler } from './core/errors';
import { GraphQLModule } from './graphql.module';
import { OpenInsuranceSharedModule } from './open-insurance/shared/shared.module';
import { RedirectDialogComponent } from './redirect-dialog/redirect-dialog.component';
import { ExtHeaderComponent } from './shared/components/ext-header/ext-header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/navigation/header/header.component';
import { MobileBottomNavigationComponent } from './shared/components/navigation/mobile-bottom-navigation/mobile-bottom-navigation.component';
import { CUSTOM_ROUTE_REUSE_STRATEGY_PROVIDER } from './shared/routing/reuse-strategy';
import { EnvironmentService } from './shared/services/environment.service';

@NgModule({
  declarations: [AppComponent, RedirectDialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    GraphQLModule,
    OpenInsuranceSharedModule,
    HeaderComponent,
    FooterComponent,
    MobileBottomNavigationComponent,
    ExtHeaderComponent
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler
    },
    CurrencyPipe,
    EnvironmentService,
    CUSTOM_ROUTE_REUSE_STRATEGY_PROVIDER
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
